import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/pc/rhCustomerService/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/pc/rhCustomerService/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/pc/rhCustomerService/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/pc/rhCustomerService/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/pc/rhCustomerService/delete/batch', {
    params: {
      ids
    }
  })
}
